import React from 'react';
import { Trans } from '@lingui/macro';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import MyAutoclaveAddForm from 'components/autoclaves/MyAutoclaveAddForm';

const MyAutoclavesPage = () => (
  <Container disableGutters>
    <Grid container component="main">
      <Grid item xs={12} sm={8} md={9}>
        <Typography paragraph>
          <Trans id="autoclave.addInfo">
            Adicione suas Autoclaves EVOXX usando o número de série para Ativar,
            Desbloquear e gerar Relatórios de manutenção.
          </Trans>
        </Typography>
      </Grid>
    </Grid>

    <Box pt={4}>
      <MyAutoclaveAddForm />
    </Box>
  </Container>
);

export default React.memo(MyAutoclavesPage);
